import {
  emitAuthorEditedBIEvent,
  emitProfileEditedBIEvent,
} from '../../services/bi-event';
import { WidgetEvent } from '../../services/data-sync-service';
import type InitialDataFetchService from '../../services/initial-data-fetch-service';
import { openProfileSavedNotification } from '../../services/modal';
import type {
  PartialUpdatableFields,
  ProfileChangePayload,
  StoreState,
  ThunkDispatch,
  ThunkExtra,
} from '../../types';
import { getShowToastAction, getToggleIsSavingProfileAction } from '../actions';
import { isBlogWriterOrEditor } from '../selectors';
import type { SetShowToastPayload } from '../slices/ui-slice';

export const toggleIsProfileSaving = (
  dispatch: ThunkDispatch,
  { dataSyncService }: ThunkExtra,
) => {
  const action = getToggleIsSavingProfileAction();

  dispatch(action);
  dataSyncService.emitEvent(action);
};

export const scheduleViewedMemberSync = ({ dataSyncService }: ThunkExtra) => {
  dataSyncService.scheduleEvent(WidgetEvent.SetViewedMember);
};

export const emitProfileEditBIEvents = (
  state: StoreState,
  updatedFields: PartialUpdatableFields,
  extra: ThunkExtra,
) => {
  emitProfileEditedBIEvent(state, updatedFields, extra);

  if (isBlogWriterOrEditor(state)) {
    emitAuthorEditedBIEvent(state, updatedFields, extra);
  }
};

export const toggleProfileSavedNotification = ({
  compId,
  flowAPI,
  wixCodeApi,
  experiments,
}: ThunkExtra) => {
  openProfileSavedNotification({
    compId,
    wixCodeApi,
    experiments,
    isMobile: flowAPI.environment.isMobile,
  });
};

export const showToast = (
  dispatch: ThunkDispatch,
  payload: SetShowToastPayload,
) => {
  dispatch(getShowToastAction(payload));
};

export const clearInitialDataCache = (
  state: StoreState,
  initialDataFetchService: InitialDataFetchService,
) => {
  const { current, viewed } = state.users;
  initialDataFetchService.clearCache(current?.uid ?? null, viewed?.uid ?? null);
};

export const notifyProfileChangeObservers = (
  { profileSubject }: ThunkExtra,
  event: ProfileChangePayload,
) => {
  if (profileSubject) {
    profileSubject.notifyObservers(event);
  }
};
